<template>
  <div>
    <CreateUpdateTemplate
      :routePreventDialog="routePreventDialog"
      :hasChanges="hasChanges"
      :customClass="'invoice-create create-form'"
      v-if="getPermission('invoice:create') || getPermission('invoice:update')"
    >
      <template v-slot:header-title>
        <div class="form-action d-flex justify-space-between">
          <div class="d-flex flex-column header-entity-visit-wrapper">
            <!-- Entity row -->
            <div class="header-row d-flex align-center mb-3">
              <span class="header-label">Entity :</span>
              <div
                v-if="selectedEntityObj && isCustomerDisabled"
                class="header-selection disabled-selection ml-3"
              >
                <span class="selection-text grey-text">{{
                  selectedEntityObj.name
                }}</span>
              </div>
              <div
                v-else-if="selectedEntityObj && !isCustomerDisabled"
                class="header-selection cursor-pointer ml-3"
                v-on:click="openEntityDialog()"
              >
                <span class="selection-text grey-text">{{
                  selectedEntityObj.name
                }}</span>
                <v-icon class="ml-1" color="#00A3E0"
                  >mdi-office-building-outline</v-icon
                >
              </div>
              <div
                v-else
                class="header-selection cursor-pointer ml-3"
                v-on:click="openEntityDialog()"
              >
                <span class="selection-text grey-text">Select an Entity</span>
                <v-icon class="ml-1" color="#00A3E0"
                  >mdi-office-building-outline</v-icon
                >
              </div>
              <entity-select
                :key="'entity-select-' + entityDialogKey"
                :dialog="entityDialog"
                :selected-entity-id="dbInvoice.entity_id"
                :entity-list="entityList"
                @close="entityDialog = false"
                @selected="onEntitySelected"
              />
            </div>

            <!-- Invoice for row -->
            <div class="header-row d-flex align-center">
              <span class="header-label">Invoice for</span>
              <div
                v-if="vCustomerId"
                class="header-selection cursor-pointer ml-3"
                v-on:click="
                  dbInvoice.entity_id && !isCustomerDisabled
                    ? openDialog('customer')
                    : null
                "
                :style="
                  !dbInvoice.entity_id || isCustomerDisabled
                    ? 'opacity:0.4; cursor:not-allowed;'
                    : ''
                "
              >
                <v-icon
                  class="mr-1"
                  :color="dbInvoice.entity_id ? '#00A3E0' : 'grey'"
                >
                  mdi-map-marker-radius-outline
                </v-icon>
                <span class="selection-text blue-text">{{
                  vCustomer.display_name
                }}</span>
                <v-icon
                  class="ml-1"
                  :color="dbInvoice.entity_id ? '#00A3E0' : 'grey'"
                >
                  mdi-account-check-outline
                </v-icon>
              </div>
              <template v-else>
                <div
                  class="header-selection cursor-pointer ml-3"
                  v-on:click="
                    dbInvoice.entity_id && !isCustomerDisabled
                      ? openDialog('customer')
                      : null
                  "
                  :style="
                    !dbInvoice.entity_id || isCustomerDisabled
                      ? 'opacity:0.4; cursor:not-allowed;'
                      : ''
                  "
                >
                  <v-icon
                    class="mr-1"
                    :color="dbInvoice.entity_id ? '#00A3E0' : 'grey'"
                  >
                    mdi-map-marker-radius-outline
                  </v-icon>
                  <span class="selection-text blue-text"
                    >Select a Customer</span
                  >
                  <v-icon
                    class="ml-1"
                    :color="dbInvoice.entity_id ? '#00A3E0' : 'grey'"
                  >
                    mdi-account-check-outline
                  </v-icon>
                </div>

                <div class="or-separator">OR</div>

                <div
                  class="header-selection cursor-pointer"
                  v-on:click="
                    dbInvoice.entity_id && !isCustomerDisabled
                      ? createCustomerDialog()
                      : null
                  "
                  :style="
                    !dbInvoice.entity_id || isCustomerDisabled
                      ? 'opacity:0.4; cursor:not-allowed;'
                      : ''
                  "
                >
                  <v-icon class="mr-1" color="#9e9e9e">
                    mdi-account-outline
                  </v-icon>
                  <span class="selection-text muted-text"
                    >Create a new Customer</span
                  >
                  <v-icon class="ml-1" color="#b0bec5">
                    mdi-plus-circle-outline
                  </v-icon>
                </div>
              </template>
            </div>
          </div>

          <div>
            <v-chip
              v-if="dbInvoice?.barcode"
              label
              color="chip-custom-blue"
              outlined
              class="text-white p-3 mr-4"
              style="font-size: 21px !important; font-weight: 700"
            >
              <template>
                {{ dbInvoice.barcode }}
              </template>
            </v-chip>
          </div>
        </div>
      </template>
      <template v-slot:header-action>
        <div>
          <v-btn
            :disabled="formLoading"
            v-on:click="goBack() /* ;clearLocalStorage() */"
            class="custom-bold-button custom-grey-border"
            depressed
            >Cancel</v-btn
          >

          <v-btn
            v-if="
              !dbUpdateInvoice?.invoice?.status ||
              dbUpdateInvoice?.invoice?.status == 1
            "
            class="custom-bold-button ml-4"
            depressed
            :disabled="
              !formValid ||
              formLoading ||
              (customError &&
                (dbInvoice?.billing_type == 'recurring' ||
                  dbInvoice?.billing_type == 'recurring-based-on-quote'))
                ? true
                : false
            "
            :loading="formLoading"
            v-on:click="validateJob('draft')"
            color="cyan white--text"
            >Save As Draft</v-btn
          >
          <v-btn
            v-if="
              !dbUpdateInvoice?.invoice?.status ||
              dbUpdateInvoice?.invoice?.status == 1
            "
            class="custom-bold-button ml-4"
            depressed
            :disabled="
              !formValid ||
              formLoading ||
              (customError && dbInvoice?.billing_type == 'recurring') ||
              dbInvoice?.billing_type == 'recurring-based-on-quote'
                ? true
                : false
            "
            :loading="formLoading"
            v-on:click="validateJob('send')"
            color="cyan white--text"
            >Save & Send</v-btn
          >

          <v-btn
            v-if="
              dbUpdateInvoice?.invoice?.status &&
              dbUpdateInvoice?.invoice?.status != 1
            "
            class="custom-bold-button ml-4"
            depressed
            :disabled="
              !formValid ||
              formLoading ||
              (customError && dbInvoice?.billing_type == 'recurring') ||
              dbInvoice?.billing_type == 'recurring-based-on-quote'
                ? true
                : false
            "
            :loading="formLoading"
            v-on:click="validateJob('save')"
            color="cyan white--text"
            >Save</v-btn
          >
        </div>
      </template>
      <template v-slot:body>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow product-create-height"
          style="position: relative"
        >
          <div class="bg-white px-2">
            <v-form
              ref="createInvoiceForm"
              v-model.trim="formValid"
              lazy-validation
              v-on:submit.stop.prevent="validateJob()"
            >
              <v-row>
                <v-col md="7">
                  <label for="visit-title" class="required">Model Title</label>
                  <TextField
                    id="quotation-title"
                    dense
                    filled
                    placeholder="Title"
                    solo
                    flat
                    counter="50"
                    v-model="dbInvoice.title"
                    color="cyan"
                    :maxlength="250"
                    :rules="[validateRules.required(dbInvoice.title, 'Title')]"
                  />

                  <TextAreaField
                    auto-grow
                    dense
                    filled
                    color="cyan"
                    v-model="dbInvoice.description"
                    placeholder="Description"
                    solo
                    flat
                    row-height="25"
                    counter="250"
                  />
                  <v-row>
                    <v-col md="6">
                      <v-layout class="align-center">
                        <v-flex md3
                          ><label class="my-0">Billing Location</label></v-flex
                        >
                        <v-flex md9 class="position-relative">
                          <v-icon
                            v-on:click="openDialog('billing')"
                            small
                            class="py-0 my-0"
                            color="cyan"
                            style="position: absolute; top: -8px"
                            >mdi-pencil</v-icon
                          >
                        </v-flex>
                      </v-layout>
                      <template v-if="vBilling?.id">
                        <p class="mb-0">
                          <span v-if="vBilling.property_name"
                            >{{ vBilling.property_name }}<br
                          /></span>
                          {{ vBilling.property_address }}
                        </p>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 red--text">
                          Please select billing location
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 red--text">Please select customer</p>
                      </template>
                      <v-layout class="mt-3 align-center">
                        <v-flex md3
                          ><label class="my-0">Contact Details</label></v-flex
                        >
                        <v-flex md9 class="position-relative">
                          <v-icon
                            small
                            v-on:click="openDialog('billing-contact')"
                            class="py-0 my-0"
                            color="cyan"
                            style="position: absolute; top: -8px"
                            >mdi-pencil</v-icon
                          >
                        </v-flex>
                      </v-layout>
                      <template v-if="vBillingContact?.id">
                        <p class="mb-0">{{ vBillingContact.display_name }}</p>
                        <p class="mb-0">{{ vBillingContact.primary_phone }}</p>
                        <p class="mb-0">{{ vBillingContact.primary_phone2 }}</p>
                        <p class="mb-0">{{ vBillingContact.primary_email }}</p>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 red--text">
                          Please select contact person
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 red--text">Please select customer</p>
                      </template>
                      <v-layout class="mt-3">
                        <v-flex md4
                          ><label class="my-0"
                            >Email Notification
                          </label></v-flex
                        >
                        <v-flex md8>
                          <v-switch
                            v-model="dbInvoice.notify_billing_contact_person"
                            class="m-0 p-0"
                            color="cyan"
                            :false-value="0"
                            :true-value="1"
                            dense
                            inset
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                    <v-col md="6">
                      <v-layout class="align-center">
                        <v-flex md3
                          ><label class="my-0">Site Location</label></v-flex
                        >
                        <v-flex md9 class="position-relative">
                          <v-icon
                            small
                            v-on:click="openDialog('property')"
                            class="py-0 my-0"
                            color="cyan"
                            style="position: absolute; top: -8px"
                            >mdi-pencil</v-icon
                          >
                        </v-flex>
                      </v-layout>

                      <template v-if="vProperty?.id">
                        <p class="mb-0">
                          <span v-if="vProperty.property_name"
                            >{{ vProperty.property_name }}<br
                          /></span>
                          {{ vProperty.property_address }}
                        </p>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 red--text">
                          Please select service location
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 red--text">Please select customer</p>
                      </template>

                      <v-layout class="mt-3 align-center">
                        <v-flex md3
                          ><label class="my-0">Contact Details</label></v-flex
                        >
                        <v-flex md9 class="position-relative">
                          <v-icon
                            small
                            v-on:click="openDialog('property-contact')"
                            class="py-0 my-0"
                            color="cyan"
                            style="position: absolute; top: -8px"
                            >mdi-pencil</v-icon
                          >
                        </v-flex>
                      </v-layout>

                      <template v-if="vPropertyContact?.id">
                        <p class="mb-0">{{ vPropertyContact.display_name }}</p>
                        <p class="mb-0">{{ vPropertyContact.primary_phone }}</p>
                        <p class="mb-0">
                          {{ vPropertyContact.primary_phone2 }}
                        </p>
                        <p class="mb-0">{{ vPropertyContact.primary_email }}</p>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 red--text">
                          Please select contact person
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 red--text">Please select customer</p>
                      </template>

                      <v-layout class="mt-3">
                        <v-flex md4
                          ><label class="my-0"
                            >Email Notification
                          </label></v-flex
                        >
                        <v-flex md8>
                          <v-switch
                            v-model="dbInvoice.notify_property_contact_person"
                            class="m-0 p-0"
                            color="cyan"
                            :false-value="0"
                            :true-value="1"
                            :disabled="formLoading"
                            dense
                            inset
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col md="5">
                  <table
                    width="100%"
                    style="table-layout: fixed"
                    v-if="is_allowed_recur_invoice"
                  >
                    <tr>
                      <!-- <td>
                        <label for="invoice-id">Type</label>
                      </td> 
                    <td colspan="2" width="100%">
                      <div class="d-flex mt-4">
                        <v-btn
                          depressed
                          tile
                          :outlined="!(dbInvoice.billing_type == 'one-off')"
                          v-on:click="dbInvoice.billing_type = 'one-off'"
                          value="one-off"
                          color="red darken-3 white--text"
                          :disabled="
                            invoiceEditId &&
                            (dbUpdateInvoice?.invoice?.billing_type ==
                              'recurring' ||
                              dbUpdateInvoice?.invoice?.billing_type ==
                                'recurring-based-on-quote')
                              ? true
                              : false
                          "
                          style="font-size: 15px; margin-right: 20px"
                          >One-Off</v-btn
                        >
                       <v-btn
                          style="font-size: 15px; margin-right: 20px"
                          class="mx-2"
                          depressed
                          tile
                          :outlined="!(dbInvoice.billing_type == 'recurring')"
                          v-on:click="dbInvoice.billing_type = 'recurring'"
                          value="recurring"
                          color="green darken-4 white--text"
                          :disabled="
                            invoiceEditId &&
                            dbUpdateInvoice?.invoice?.billing_type == 'one-off'
                              ? true
                              : false
                          "
                          >Recurring</v-btn
                        > 
                      </div>
                    </td> -->
                    </tr>
                  </table>
                  <table
                    width="100%"
                    style="table-layout: fixed"
                    v-if="
                      (dbInvoice?.billing_type == 'recurring' ||
                        dbInvoice?.billing_type ==
                          'recurring-based-on-quote') &&
                      !invoiceEditId
                    "
                  >
                    <tr>
                      <td width="100%">
                        <div>
                          <RecurringSchedule
                            :key="`job-recurring-schedule-${scheduleKey}`"
                          />
                        </div>
                      </td>
                    </tr>
                  </table>
                  <table width="100%" style="table-layout: fixed">
                    <tr
                      v-if="
                        (dbInvoice?.billing_type == 'recurring' ||
                          dbInvoice?.billing_type ==
                            'recurring-based-on-quote') &&
                        !invoiceEditId
                      "
                    >
                      <td width="20%" v-if="false">
                        <label for="invoice-id">Type</label>
                      </td>
                      <td width="80%" v-if="false">
                        <v-autocomplete
                          id="payment-due"
                          dense
                          :disabled="formLoading"
                          :loading="formLoading"
                          v-model="dbInvoice.recurring_type"
                          item-text="text"
                          item-value="text"
                          item-color="cyan"
                          filled
                          :items="recurringTypeList"
                          hide-details
                          placeholder="Recurring Invoive"
                          solo
                          flat
                          color="cyan"
                        />
                      </td>
                      <!-- <td width="40%">
                        <v-text-field
                         v-on:keypress="isNumber()" 
                          type="number"
                          dense
                          filled
                          hide-details
                          placeholder="Duration"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          :value="dbInvoice.recurring_duration_new"
                          color="cyan"
                        />   
                      </td> -->
                    </tr>
                    <tr v-if="false">
                      <td width="20%" colspan="2">
                        <label for="invoice-id">Invoice #</label>
                      </td>
                      <td>
                        <v-text-field
                          id="invoice-id"
                          dense
                          filled
                          readonly
                          hide-details
                          placeholder="Invoice #"
                          :maxlength="250"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          :value="dbInvoice.barcode"
                          color="cyan"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="visit-id">Installation Visit</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-autocomplete
                          id="visit-list"
                          dense
                          :items="vRelatedVisits"
                          clearable
                          filled
                          v-model="dbInvoice.visit"
                          hide-details
                          placeholder="Visit"
                          item-text="text"
                          item-color="cyan"
                          item-value="value"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          @change="onVisitChangedByUser"
                          color="cyan"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="reference">Reference #</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="reference"
                          dense
                          filled
                          v-model="dbInvoice.customer_ref"
                          :maxlength="250"
                          hide-details
                          placeholder="Reference #"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                        />
                      </td>
                    </tr>
                    <tr v-if="dbInvoice.billing_type != 'recurring'">
                      <td width="20%">
                        <label for="invoice-date">Invoice Date</label>
                      </td>
                      <td width="80%" colspan="2">
                        <date-picker
                          :disabled="formLoading"
                          :loading="formLoading"
                          key="invoice-date"
                          id="invoice-date"
                          placeholder="Invoice Date"
                          v-model="dbInvoice.date"
                          :min-date="invoiceMinDate"
                          :max-date="invoiceMaxDate"
                        />
                      </td>
                    </tr>

                    <tr v-if="isOldInvoiceRequired && invoiceEditId <= 0">
                      <td width="15%">
                        <label for="old-invoice-no" class="required"
                          >Old Invoice No.</label
                        >
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="old-invoice-no"
                          dense
                          filled
                          v-model="dbInvoice.old_invoice_no"
                          :maxlength="50"
                          hide-details
                          placeholder="Old Invoice No."
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          :rules="[
                            validateRules.required(
                              dbInvoice.old_invoice_no,
                              'Old Invoice No.'
                            ),
                          ]"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="payment-due">Payment due</label>
                      </td>

                      <td width="80%" colspan="2">
                        <v-autocomplete
                          id="payment-due"
                          dense
                          :disabled="formLoading"
                          :loading="formLoading"
                          :menu-props="{ auto: false, offsetY: true }"
                          open-on-focus
                          v-model="dbInvoice.payment_due"
                          :items="customerPaymentTerms"
                          item-text="text"
                          item-value="id"
                          filled
                          solo
                          attach
                          flat
                          hide-details
                          color="cyan"
                          placeholder="Payment due"
                          append-outer-icon="mdi-cog"
                          @click:append-outer="PaymentData"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="po-number">P/O Number</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="po-number"
                          dense
                          filled
                          v-model="dbInvoice.po_number"
                          :maxlength="20"
                          hide-details
                          placeholder="P/O Number"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="po-number">Event / Roadshow Name</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="event-other-purpsoe"
                          dense
                          filled
                          v-model="dbInvoice.event_purpose"
                          :maxlength="100"
                          hide-details
                          placeholder="Event / Roadshow Name"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="product-specialist"
                          >Product Specialist</label
                        >
                      </td>
                      <td width="80%" colspan="2">
                        <v-autocomplete
                          id="product-specialist"
                          attach
                          :menu-props="{ auto: false, offsetY: true }"
                          dense
                          :disabled="formLoading"
                          :loading="formLoading"
                          v-model="dbInvoice.product_specialist"
                          :items="productSpecialistList"
                          placeholder="Product Specialist"
                          solo
                          flat
                          item-text="text"
                          item-value="text"
                          filled
                          color="cyan"
                          multiple
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  No Product Specialist(s) Found.
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <template v-slot:append-outer>
                            <v-icon
                              @click.stop="productSpecialistDialog = true"
                            >
                              mdi-cog
                            </v-icon>
                          </template>
                        </v-autocomplete>
                        <!-- <v-autocomplete
                        v-else
                        id="product-specialist"
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.product_specialist"
                        item-text="text"
                        item-value="value"
                        item-color="cyan"
                        filled
                        :items="productSpecialistList"
                        hide-details
                        placeholder="Product Specialist"
                        solo
                        flat
                        color="cyan"
                      /> -->
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="outlet">Outlet</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-autocomplete
                          dense
                          color="cyan"
                          filled
                          id="outlet"
                          :items="outletList"
                          :disabled="
                            formLoading ||
                            outletsLoading ||
                            !dbInvoice.entity_id
                          "
                          :loading="outletsLoading"
                          v-model.trim="dbInvoice.outlet"
                          placeholder="Select Outlet"
                          solo
                          flat
                          item-color="cyan"
                          item-text="label"
                          item-value="id"
                          hide-details
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{
                                    !dbInvoice.entity_id
                                      ? "Please select an Entity first."
                                      : "No Outlet Available."
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="prepared-by">Prepared by</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-autocomplete
                          dense
                          color="cyan"
                          filled
                          id="prepared-by"
                          :items="admin_sales"
                          :disabled="formLoading"
                          :loading="formLoading"
                          v-model.trim="dbInvoice.prepared_by_id"
                          placeholder="Prepared by"
                          solo
                          flat
                          item-color="cyan"
                          item-text="display_name"
                          item-value="id"
                          hide-details
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-html="'No User Found.'"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label
                          for="pos-receipt-no"
                          :class="{ required: dbInvoice.entity_id === 2 }"
                        >
                          POS Receipt No.
                        </label>
                      </td>

                      <td width="80%" colspan="2">
                        <v-text-field
                          id="pos-receipt-no"
                          v-model.trim="dbInvoice.pos_receipt_no"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          placeholder="POS Receipt No."
                          :rules="[
                            ...(dbInvoice.entity_id === 2
                              ? [
                                  validateRules.required(
                                    dbInvoice.pos_receipt_no,
                                    'POS Receipt No.'
                                  ),
                                ]
                              : []),
                            validateRules.maxLength(
                              dbInvoice.pos_receipt_no,
                              'POS Receipt No.',
                              100
                            ),
                          ]"
                          solo
                          flat
                        ></v-text-field>
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="referral-fee">Referral Fee</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="referral-fee"
                          v-model.trim="dbInvoice.referral_fee"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          placeholder="Referral Fee"
                          :maxlength="100"
                          :rules="[
                            validateRules.maxLength(
                              dbInvoice.referral_fee,
                              'Referral Fee',
                              100
                            ),
                          ]"
                          solo
                          flat
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="promotion">Promotion</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="promotion"
                          v-model.trim="dbInvoice.promotion"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          placeholder="Promotion"
                          :maxlength="100"
                          :rules="[
                            validateRules.maxLength(
                              dbInvoice.promotion,
                              'Promotion',
                              100
                            ),
                          ]"
                          solo
                          flat
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="lead-booking-by">Heard From</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-select
                          id="lead-booking-by"
                          clearable
                          :menu-props="{ auto: false, offsetY: true }"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          item-color="cyan"
                          :items="leadBookingByOptions"
                          placeholder="Heard From"
                          solo
                          flat
                          class="width-70"
                          v-model="leadBookingBySelection"
                          @change="handleLeadBookingByChange"
                        >
                        </v-select>
                      </td>
                    </tr>
                    <tr v-if="leadBookingByOtherSelected">
                      <td width="20%">
                        <label for="lead-booking-by-other"
                          >Heard From Text</label
                        >
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="lead-booking-by-other"
                          v-model.trim="leadBookingByOther"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          placeholder="Heard From Text"
                          :maxlength="50"
                          counter="50"
                          :rules="[
                            validateRules.maxLength(
                              leadBookingByOther,
                              'Heard From Text',
                              50
                            ),
                          ]"
                          solo
                          flat
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <label for="Group by">Groupbuy</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-text-field
                          id="group-by"
                          v-model.trim="dbInvoice.group_by"
                          dense
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          color="cyan"
                          placeholder="Groupbuy"
                          :rules="[
                            validateRules.maxLength(
                              dbInvoice.group_by,
                              'Groupbuy',
                              100
                            ),
                          ]"
                          solo
                          flat
                        ></v-text-field>
                      </td>
                    </tr>

                    <tr>
                      <td width="20%">
                        <label for="delivery-method">Delivery Method</label>
                      </td>
                      <td width="80%" colspan="2">
                        <v-autocomplete
                          id="delivery-method"
                          dense
                          :disabled="formLoading"
                          :loading="formLoading"
                          v-model="dbInvoice.delivery_method"
                          item-text="text"
                          item-value="text"
                          item-color="cyan"
                          filled
                          :items="deliveryMethodList"
                          hide-details
                          placeholder="Delivery Method"
                          solo
                          flat
                          color="cyan"
                          append-outer-icon="mdi-cog"
                          @click:append-outer="deliveryMethodDialog = true"
                        />
                      </td>
                    </tr>
                    <tr v-if="dbInvoice.payment_due == 5">
                      <td width="20%">
                        <label for="due-date">Due date</label>
                      </td>
                      <td width="80%" colspan="2">
                        <date-picker
                          :disabled="formLoading"
                          :loading="formLoading"
                          key="due-date"
                          id="due-date"
                          :min-date="dbInvoice.date"
                          placeholder="Due Date"
                          v-model="dbInvoice.due_date"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <div
                          class="font-weight-600"
                          style="color: black; font-size: 15px"
                        >
                          {{ $route?.query?.message }}
                        </div>
                      </td>
                    </tr>
                    <!--  <tr v-if="dbQuotation?.id">
              <td>
                <label for="quotation-id">Quotation</label>
              </td>
              <td>
                <v-text-field
                  id="quotation-id"
                  dense
                  filled
                  readonly
                  :value="`${dbQuotation.barcode} - ${dbQuotation.title}`"
                  hide-details
                  placeholder="Quotation"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr>
            <tr v-else>
              <td>
                <label for="quotation-list">Quotation</label>
              </td>
              <td>
                <v-autocomplete
                  id="quotation-list"
                  dense
                  :items="vRelatedQuotations"
                  filled
                  v-model="dbInvoice.quotation"
                  hide-details
                  placeholder="Quotation"
                  item-text="text"
                  item-color="cyan"
                  item-value="value"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr> -->
                  </table>
                </v-col>
                <v-col cols="12" ref="qtLineItem">
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-title class="headline grey lighten-4">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue"
                      >
                        Line Items
                      </h3>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <line-item
                        is-job
                        :unit="unit"
                        :related-type="related_type"
                        ref="invoiceLineItem"
                        :related-detail="dbUpdateInvoice?.invoice"
                        :key="`invoice-line-item-${uniqueId}`"
                        :invoice-id="Number(invoiceEditId)"
                        is-invoice
                        :entity-data="selectedEntityObj"
                        :entity-id="selectedEntityId"
                        :entity-list="entityList"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" ref="qtPaymentTerm" v-if="false">
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-title class="headline grey lighten-4">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue"
                      >
                        PAYMENT TERMS
                      </h3>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-autocomplete
                        v-if="false"
                        dense
                        color="cyan"
                        filled
                        label="Payment Terms"
                        solo
                        flat
                        class="my-2"
                        item-color="cyan"
                        item-text="label"
                        item-value="id"
                        hide-details
                        :disabled="formLoading"
                        :loading="formLoading"
                        :items="paymentTermList"
                        v-model="dbInvoice.payment_term_id"
                        v-on:change="update_payment_term()"
                      >
                      </v-autocomplete>
                      <TinyMCE v-model="dbInvoice.payment_terms" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" ref="qtTermCondition">
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-title class="headline grey lighten-4">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue"
                      >
                        Terms &amp; Conditions
                      </h3>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        label="Terms &amp; Conditions"
                        solo
                        flat
                        class="my-2"
                        item-color="cyan"
                        item-text="label"
                        item-value="id"
                        hide-details="auto"
                        :disabled="formLoading"
                        :loading="formLoading"
                        :items="termsConditionList"
                        :rules="[
                          validateRules.required(
                            dbInvoice.term_condition_id,
                            'Terms & Conditions',
                            true
                          ),
                        ]"
                        v-model="dbInvoice.term_condition_id"
                        v-on:change="update_term_condition()"
                      >
                      </v-autocomplete>
                      <TinyMCE
                        :disabled="currentUser?.role == '5'"
                        v-model="dbInvoice.term_conditions"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pb-15" ref="qtNote">
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-title class="headline grey lighten-4">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue"
                      >
                        INTERNAL NOTES &amp; ATTACHMENTS
                      </h3>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-layout>
                        <v-flex class="mr-4" md6>
                          <label class="font-size-16 font-weight-600"
                            >Internal Note</label
                          >
                          <v-autocomplete
                            dense
                            color="cyan"
                            filled
                            label="Internal Note"
                            solo
                            flat
                            class="my-2"
                            item-color="cyan"
                            item-text="label"
                            item-value="id"
                            hide-details
                            :disabled="formLoading"
                            :loading="formLoading"
                            :items="adminNoteList"
                            v-model="dbInvoice.admin_note_id"
                            v-on:change="update_admin_note()"
                            v-if="false"
                          >
                          </v-autocomplete>
                          <TinyMCE v-model="dbInvoice.admin_note" />
                        </v-flex>
                        <v-flex md6>
                          <label class="font-size-16 font-weight-600"
                            >Remarks
                            <span class="text--secondary font-weight-500"
                              >(visible on PDF)</span
                            ></label
                          >
                          <v-autocomplete
                            dense
                            color="cyan"
                            filled
                            label="Remarks"
                            solo
                            flat
                            class="my-2"
                            item-color="cyan"
                            item-text="label"
                            item-value="id"
                            hide-details
                            :disabled="formLoading"
                            :loading="formLoading"
                            :items="clientNoteList"
                            v-model="dbInvoice.client_note_id"
                            v-on:change="update_client_note()"
                            v-if="false"
                          >
                          </v-autocomplete>
                          <TinyMCE v-model="dbInvoice.client_note" />
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-4">
                        <v-flex md12 class="mr-4" v-if="false">
                          <label class="font-size-16 font-weight-600"
                            >Attachments</label
                          >
                          <FileUpload
                            v-model="dbInvoice.attachments"
                            :maxLimit="5"
                          >
                          </FileUpload>
                          <table width="100%" v-if="false">
                            <tbody>
                              <tr
                                v-for="(row, index) in dbInvoice.attachments"
                                :key="`prev-attach-${index}`"
                              >
                                <td width="50%" class="pr-2 py-2">
                                  <v-text-field
                                    prepend-inner-icon="mdi-attachment mdi-rotate-90"
                                    placeholder="File Name"
                                    label="File Name"
                                    dense
                                    solo
                                    flat
                                    readonly
                                    color="cyan"
                                    v-model="row.name"
                                    hide-details
                                  ></v-text-field>
                                </td>
                                <td width="50%" class="pl-2 py-2">
                                  <v-text-field
                                    placeholder="File Name"
                                    label="File Name"
                                    dense
                                    solo
                                    flat
                                    color="cyan"
                                    v-model="row.name"
                                    hide-details
                                    class="has-delete-outer-icon"
                                    append-outer-icon="mdi-delete"
                                    v-on:click:append-outer="
                                      remove_row('dbInvoice.attachments', index)
                                    "
                                    :suffix="`.${row.ext}`"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr
                                v-for="(row, index) in attachments"
                                :key="index"
                              >
                                <td width="50%" class="pr-2 py-2">
                                  <v-file-input
                                    prepend-inner-icon="mdi-attachment mdi-rotate-90"
                                    placeholder="Click here to select file"
                                    label="Click here to select file"
                                    prepend-icon=""
                                    color="cyan"
                                    solo
                                    flat
                                    :disabled="formLoading"
                                    :loading="formLoading"
                                    v-model="row.accepted_file"
                                    dense
                                    v-on:change="update_file_name(index)"
                                    hide-details
                                  ></v-file-input>
                                </td>
                                <td width="50%" class="pl-2 py-2">
                                  <v-text-field
                                    placeholder="File Name"
                                    label="File Name"
                                    dense
                                    solo
                                    flat
                                    :disabled="formLoading"
                                    :loading="formLoading"
                                    color="cyan"
                                    v-model="row.file_name"
                                    :maxlength="250"
                                    hide-details
                                    class="has-delete-outer-icon"
                                    append-outer-icon="mdi-delete"
                                    v-on:click:append-outer="
                                      remove_row('attachments', index)
                                    "
                                    :suffix="get_file_extension(row.file_type)"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td height="10px" colspan="2"></td>
                              </tr>
                              <tr>
                                <td colspan="2">
                                  <v-btn
                                    color="cyan white--text"
                                    small
                                    :disabled="formLoading"
                                    v-on:click="add_attachment_row()"
                                    class="custom-bold-button"
                                    >Add More...</v-btn
                                  >
                                </td>
                              </tr>
                              <tr>
                                <td height="10px" colspan="2"></td>
                              </tr>
                            </tbody>
                          </table>
                        </v-flex>
                        <v-flex md12 class="">
                          <DocumnetList
                            :extensive="false"
                            v-model="dbInvoice.attachments"
                            :document-type="3"
                          >
                          </DocumnetList>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </perfect-scrollbar>
        <customer-select
          :dialog="reCustomerDialog"
          :entity-id="dbInvoice.entity_id"
          @close="closeCustomerDialog"
        />
        <customer-create :key="`invoice-customer-create-${dailogKey}`" />

        <person-select
          :dialog="contactDialog"
          v-on:close="contactDialog = false"
          :type="contactType"
        />

        <address-select
          :dialog="propertyDialog"
          v-on:close="propertyDialog = false"
          :type="propertyType"
          :label="propertyLabel"
        />
      </template>
      <!--  <ManagePaymentTerms
        :bDialog="managePaymentDialog"
        :customerPaymentTerms="customerPaymentTerms"
        v-on:close-dialog="managePaymentDialog = false"
        v-on:get-customer-payment-term="get_attributes"
      /> -->
      <!-- <ManagePaymentTerms
      :bDialog="managePaymentDialog"
      :customerPaymentTerms="customerPaymentTerms"
      @close-dialog="onPaymentDialogClose = false"
      @get-customer-payment-term="get_attributes"
    /> -->
    </CreateUpdateTemplate>
    <ManagePaymentTerms
      :bDialog="managePaymentDialog"
      :customerPaymentTerms="customerPaymentTerms"
      v-on:close-dialog="managePaymentDialog = false"
      v-on:get-customer-payment-term="get_attributes"
    />
    <ProductSpecialists
      :dialog="productSpecialistDialog"
      :product_specialists="productSpecialistList"
      @close-dialog="productSpecialistDialog = false"
      @get-product-specialists="getProductSpecialists"
    ></ProductSpecialists>
    <!-- <LeadBookingBys
      :dialog="leadBookingByDialog"
      :lead_booking_bys="leadBookingByList"
      @close-dialog="leadBookingByDialog = false"
      @get-lead-booking-bys="getLeadBookingBys"
    ></LeadBookingBys> -->
    <ManageDeliveryMethods
      :dialog="deliveryMethodDialog"
      :delivery_methods="deliveryMethodList"
      @close-dialog="deliveryMethodDialog = false"
      @get-delivery-methods="getDeliveryMethods"
    />
  </div>
</template>

<script>
import EntitySelect from "@/view/components/EntitySelect.vue";
import { mapGetters } from "vuex";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DatePicker from "@/view/components/QDatePicker.vue";
import LineItemV2 from "@/view/pages/partials/Line-Item-Invoice.vue";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import ManagePaymentTerms from "@/view/pages/partials/Manage-Payment-Terms.vue";
import ProductSpecialists from "../partials/Product-Specialists.vue";
// import LeadBookingBys from "../partials/Lead-Booking-Bys.vue";
import ManageDeliveryMethods from "../partials/Manage-Delivery-Methods.vue";

import moment from "moment-timezone";
import ObjectPath from "object-path";
//import FileUpload from "@/view/components/app-component/FileInput.vue";
import DocumnetList from "@/view/pages/DocumnetList";
import {
  SET_CUSTOMER,
  SET_BILLING,
  SET_BILLING_CONTACT,
  SET_PROPERTY,
  SET_PROPERTY_CONTACT,
  RESET_CREATE_STATE,
  // SET_VISIT_LINE_ITEM,
  RESET_CUSTOMER_STATE,
} from "@/core/services/store/visit.module";
import { CLEAR_INVOICE } from "@/core/services/store/invoice.module";
import {
  CLEAR_CUSTOMER,
  SET_CREATE_DIALOG_STATUS,
  SET_DIALOG_STATUS,
  GET_CUSTOMER_RELATED,
} from "@/core/services/store/customer.module";
import {
  UPLOAD,
  QUERY,
  POST,
  PATCH,
} from "@/core/services/store/request.module";
import {
  SET_UOM,
  SET_GST,
  SET_EDIT_LINE_ITEM,
  SET_EDIT_CALCULATION,
  CLEAR_LINE_ITEM,
} from "@/core/services/store/line.item.module";
import CustomerCreate from "@/view/components/CustomerCreateDialog.vue";
import CustomerSelect from "@/view/components/CustomerSelect.vue";
import PersonSelect from "@/view/components/PersonSelect.vue";
import AddressSelect from "@/view/components/AddressSelect.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";

import KTCookie from "@/assets/js/components/cookie";
import CommonMixin from "@/core/plugins/common-mixin";
import RecurringSchedule from "@/view/pages/invoice/RecurringInvoiceSchedule.vue";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "create-invoice",
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      entityDialogKey: 0,
      invoiceEditId: 0,
      formLoading: false,
      invoiceCreated: false,
      formValid: true,
      dbQuotation: {},
      dbVisit: {},
      admin_sales: [],
      customerPaymentTerms: [],
      managePaymentDialog: false,
      dbEnquiry: {},
      related_type: 2,
      productSpecialistList: new Array(),
      productSpecialistDialog: false,
      leadBookingByList: new Array(),
      leadBookingBySelection: null,
      leadBookingByOther: "",
      leadBookingByOtherSelected: false,
      leadBookingByOptions: [
        "Referral",
        "Groupbuy",
        "Retail",
        "Showroom",
        "Facebook",
        "Instagram",
        "Google",
        "ID",
        "Walk-in",
        "Roadshow/Event",
        "Others",
      ],
      leadBookingByDialog: false,
      scheduleKey: Number(new Date()),
      dailogKey: Number(new Date()),
      uniqueId: Number(new Date()),
      is_allowed_recur_invoice: false,
      dbUpdateInvoice: {},
      defaultClientNote:
        "<p>1. Lifetime parts warranty<br>2. One year motor warranty (after warranty, repair cap @ $200 max)<br>3. First Year Transport & Labour FOC (Subsequently cap @ $80 max)<br>4. Yearly free onsite servicing and change filters (no transport and labour cost)<br>5. Future trade in value @ $1000</p>",
      entity_name: null,
      recurringTypeList: [
        {
          value: "daily",
          text: "Daily",
        },
        {
          value: "weakly",
          text: "Weekly",
        },
        {
          value: "monthly",
          text: "Monthly",
        },
        {
          value: "yearly",
          text: "Yearly",
        },
      ],
      dbInvoice: {
        title: null,
        description: null,
        event_purpose: null,
        entity_id: null,
        notify_billing_contact_person: null,
        notify_property_contact_person: null,
        barcode: null,
        customer_ref: null,
        date: null,
        payment_due: "2",
        due_date: null,
        po_number: null,
        pos_receipt_no: null,
        referral_fee: null,
        promotion: null,
        invoice_specialist_type: null,
        product_specialist: null,
        lead_booking_by: null,
        lead_booking_by_other: null,
        ticket: 0,
        visit: 0,
        quotation: 0,
        payment_term_id: 0,
        payment_terms: null,
        term_condition_id: 0,
        term_conditions: null,
        admin_note_id: 0,
        admin_note: null,
        client_note_id: 0,
        group_by: null,
        client_note: null,
        billing_type: "one-off",
        recurring_type: "monthly",
        recurring_duration_new: 1,
        old_invoice_no: null,
        attachments: [
          {
            file: null,
            name: null,
            remark: null,
            suffix: null,
            tags: null,
            search: null,
            start_date: null,
            end_date: null,
            reminder_date: null,
          },
        ],
      },
      attachments: [
        {
          accepted_file: null,
          file_name: null,
          file_type: null,
        },
      ],
      adminNoteList: [],
      unit: [],
      clientNoteList: [],
      termsConditionList: [],
      paymentTermList: [],
      paymentDueList: [],
      userList: [],
      todayDate: null,
      customerDialog: false,
      propertyType: null,
      propertyLabel: null,
      propertyDialog: false,
      contactType: null,
      contactDialog: false,
      /*  productSpecialistList: [], */
      deliveryMethodList: [],
      deliveryMethodDialog: false,
      entityList: [],
      isVisitChanged: false,
      entityDialog: false,
      outletList: [],
      outletsLoading: false,
    };
  },
  components: {
    "customer-select": CustomerSelect,
    "customer-create": CustomerCreate,

    "person-select": PersonSelect,
    "address-select": AddressSelect,
    "line-item": LineItemV2,
    "date-picker": DatePicker,
    TinyMCE,
    // FileUpload,
    CreateUpdateTemplate,
    DocumnetList,
    RecurringSchedule,
    TextAreaField,
    ManagePaymentTerms,
    ProductSpecialists,
    // LeadBookingBys,
    ManageDeliveryMethods,
    "entity-select": EntitySelect,
  },
  methods: {
    handleLeadBookingByChange(value) {
      this.setLeadBookingBy(value);
    },
    setLeadBookingBy(value, otherValue = null) {
      if (this.leadBookingByOptions.indexOf(value) !== -1) {
        this.leadBookingBySelection = value;
        this.leadBookingByOtherSelected = value === "Others";
        this.dbInvoice.lead_booking_by = value;
        this.leadBookingByOther = value === "Others" ? otherValue || "" : "";
        return;
      }

      if (value) {
        this.leadBookingBySelection = "Others";
        this.leadBookingByOtherSelected = true;
        this.dbInvoice.lead_booking_by = "Others";
        this.leadBookingByOther = otherValue || value;
        return;
      }

      this.leadBookingBySelection = null;
      this.leadBookingByOtherSelected = false;
      this.dbInvoice.lead_booking_by = null;
      this.leadBookingByOther = "";
    },
    PaymentData() {
      this.managePaymentDialog = true;
    },
    openEntityDialog() {
      if (this.isCustomerDisabled) return;
      this.entityDialogKey++;
      this.entityDialog = true;
    },
    ProductSpecialists() {
      this.productSpecialistDialog = true;
      this.get_attributes();
    },
    getProductSpecialists(productSpecialists) {
      this.productSpecialistList = productSpecialists;
    },
    getLeadBookingBys(leadBookingBys) {
      this.leadBookingByList = leadBookingBys;
    },
    getDeliveryMethods(deliveryMethods) {
      this.deliveryMethodList = deliveryMethods;
    },
    normalizeProductSpecialists(value) {
      if (!value) return [];

      return Array.isArray(value)
        ? value.map((i) => i?.text ?? i?.value ?? i?.name ?? i).filter(Boolean)
        : typeof value === "string"
        ? value
            .split(",")
            .map((i) => i.trim())
            .filter(Boolean)
        : [value];
    },
    onEntitySelected(entity) {
      if (this.isCustomerDisabled) return;
      this.entityDialog = false;
      const isEntityChanging =
        this.dbInvoice.entity_id && this.dbInvoice.entity_id !== entity.id;

      if (isEntityChanging) {
        this.$store.commit(RESET_CUSTOMER_STATE);
        Object.assign(this.dbInvoice, {
          notify_billing_contact_person: null,
          notify_property_contact_person: null,
          outlet: null,
          quotation: 0,
        });
      }
      this.dbInvoice.entity_id = entity.id;
      this.dbInvoice.entity_name = entity.name;
      this.fetchOutlets(entity.id);
      this.get_attributes();
    },
    fetchOutlets(entityId, preselectOutletId = null) {
      this.outletList = [];
      if (preselectOutletId === undefined) {
        this.dbInvoice.outlet = null;
      }

      if (!entityId) return;

      this.outletsLoading = true;

      this.$store
        .dispatch(QUERY, {
          url: "getOutlet",
          data: { entity_id: entityId },
        })
        .then((response) => {
          this.outletList = response.data;
          if (preselectOutletId != null) {
            this.dbInvoice.outlet = preselectOutletId;
          }
        })
        .catch((error) => {
          this.logError(error);
          this.outletList = [];
        })
        .finally(() => {
          this.outletsLoading = false;
        });
    },
    closeCustomerDialog() {
      this.$store.commit(SET_DIALOG_STATUS, false);
    },

    onVisitChangedByUser() {
      this.isVisitChanged = true;
    },

    createCustomerDialog() {
      this.dialog_key = Number(new Date());
      this.$nextTick(() => {
        this.$store.commit(SET_CREATE_DIALOG_STATUS, true);
      });
    },
    getItemKey(item) {
      if (item?.id) return `id:${item.id}`;
      if (item?.uuid) return `uuid:${item.uuid}`;
      return `row:${item.order}`;
    },
    clearLocalStorage() {
      localStorage.removeItem("milesttone");
    },
    remove_row(target, index) {
      ObjectPath.del(this, `${target}.${index}`);
      this.$nextTick(() => {
        if (!this.attachments.length) {
          this.add_attachment_row();
        }
      });
    },
    add_attachment_row() {
      this.attachments.push({
        accepted_file: null,
        file_name: null,
        file_type: null,
      });
    },
    get_file_extension(file_type) {
      if (file_type) {
        return `.${file_type}`;
      }
      return null;
    },
    update_file_name(index) {
      const file = this.attachments[index].accepted_file;
      if (file) {
        this.attachments[index].file_name = file.name
          .split(".")
          .slice(0, -1)
          .join(".");
        this.attachments[index].file_type = file.name.split(".").pop();
        this.add_attachment_row();
      }
    },
    update_payment_term() {
      let output = this.lodash.find(this.paymentTermList, {
        id: this.dbInvoice.payment_term_id,
      });
      if (output) {
        this.dbInvoice.payment_terms = output.description;
      }
    },
    update_term_condition() {
      let output = this.lodash.find(this.termsConditionList, {
        id: this.dbInvoice.term_condition_id,
      });
      if (output) {
        this.dbInvoice.term_conditions = output.description;
      }
    },
    update_admin_note() {
      let output = this.lodash.find(this.adminNoteList, {
        id: this.dbInvoice.admin_note_id,
      });
      if (output) {
        this.dbInvoice.admin_note = output.description;
      }
    },
    update_client_note() {
      let output = this.lodash.find(this.clientNoteList, {
        id: this.dbInvoice.client_note_id,
      });
      if (output) {
        this.dbInvoice.client_note = output.description;
      }
    },
    uploadFiles() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        let status = false;

        for (let i = 0; i < _this.attachments.length; i++) {
          if (_this.attachments[i].accepted_file) {
            status = true;
            formData.append(
              `files[${i}]`,
              _this.attachments[i].accepted_file,
              _this.attachments[i].file_name
            );
          }
        }

        if (!status) {
          resolve([]);
        } else {
          _this.$store
            .dispatch(UPLOAD, { url: "file-manager/upload", data: formData })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    openDialog(type) {
      if (type === "customer" && !this.dbInvoice.entity_id) {
        ErrorEventBus.$emit("update:error", "Please Select an Entity first.");
        return false;
      }
      this.$store.commit(SET_DIALOG_STATUS, false);
      this.propertyType = null;
      this.propertyLabel = null;
      this.propertyDialog = false;
      this.contactType = null;
      this.contactDialog = false;

      if (type == "customer") {
        this.$store.commit(SET_DIALOG_STATUS, true);
      } else {
        if (!this.vCustomerId) {
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "billing") {
          this.propertyType = "billing";
          this.propertyLabel = "Billing Location";
          this.propertyDialog = true;
        }
        if (type == "billing-contact") {
          this.contactType = "billing";
          this.contactDialog = true;
        }
        if (type == "property") {
          this.propertyType = "property";
          this.propertyLabel = "Site Location";
          this.propertyDialog = true;
        }
        if (type == "property-contact") {
          this.contactType = "property";
          this.contactDialog = true;
        }
      }
    },
    validateJob(type) {
      if (!this.dbInvoice.entity_id) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }
      if (!this.vCustomerId) {
        ErrorEventBus.$emit("update:error", "Select Customer");
        return false;
      }
      if (!this.vPropertyId) {
        ErrorEventBus.$emit("update:error", "Select Service Location");
        return false;
      }

      if (!this.vPropertyContactId) {
        ErrorEventBus.$emit("update:error", "Select Service Contact Person");
        return false;
      }

      if (!this.vBillingId) {
        ErrorEventBus.$emit("update:error", "Select Billing Location");
        return false;
      }

      if (!this.vBillingContactId) {
        ErrorEventBus.$emit("update:error", "Select Billing Contact Person");
        return false;
      }

      if (!this.dbInvoice.term_condition_id) {
        ErrorEventBus.$emit("update:error", "Terms & Conditions is required");
        return false;
      }

      const termConditionsText = this.dbInvoice.term_conditions
        ? this.dbInvoice.term_conditions.replace(/<[^>]*>/g, "").trim()
        : "";
      if (!termConditionsText) {
        ErrorEventBus.$emit(
          "update:error",
          "Terms & Conditions paragraph is required"
        );
        return false;
      }

      if (!this.vSelectedLineItem || !this.vSelectedLineItem.length) {
        ErrorEventBus.$emit("update:error", "Select Line Item");
        return false;
      }
      const AllItems = this.vSelectedLineItem;
      if (AllItems?.length > 0) {
        for (var k = 0; k < AllItems.length; k++) {
          if (!AllItems[k].product) {
            ErrorEventBus.$emit(
              "update:error",
              AllItems[k].type + " title is required."
            );
            return false;
          }
        }
      }
      const validateStatus = this.$refs.createInvoiceForm.validate();

      const formErrors = this.validateForm(this.$refs.createInvoiceForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit(type);
      }
    },
    async onSubmit(type) {
      const new_attachments = await this.uploadFiles();
      this.dbInvoice.quotation = this.$route?.query?.quotation
        ? this.lodash.toSafeInteger(this.$route.query.quotation)
        : null;

      const request = {
        ...this.dbInvoice,
        attachments: [...this.dbInvoice.attachments, ...new_attachments],
        customer: this.vCustomerId,
        property: this.vPropertyId,
        sent: type == "send" ? 1 : 0,
        recurring:
          this.dbInvoice.billing_type == "recurring"
            ? this.invoiceRecurringSchedule
            : {},
        schedule:
          this.dbInvoice.billing_type == "recurring"
            ? this.invoiceScheduleOutput
            : [],
        billing: this.vBillingId,
        property_contact_person: this.vPropertyContactId,
        billing_contact_person: this.vBillingContactId,
        enquiry: this.lodash.toSafeInteger(this.dbEnquiry?.id),
        ticket: this.lodash.toSafeInteger(this.dbInvoice?.ticket) || 0,
        milestone: this.$route?.query?.milestone
          ? this.lodash.toSafeInteger(this.$route.query.milestone)
          : null,
        milestone_amount: this.$route?.query?.milestone_amount
          ? this.$route.query.milestone_amount
          : null,
        payment_type: this.$route?.query?.payment
          ? this.$route?.query?.payment
          : null,
        po_number: this.dbInvoice.po_number,
        product_specialist: this.dbInvoice.product_specialist,
        lead_booking_by: this.dbInvoice.lead_booking_by,
        lead_booking_by_other:
          this.leadBookingBySelection === "Others"
            ? this.leadBookingByOther
            : null,
        "line-item": this.vSelectedLineItem,
        calculation: this.vCalculations,
      };

      this.formLoading = true;
      let requestType = POST;
      let requestURL = "invoice-v1";

      let invoiceId = this.$route?.query?.invoice ?? 0;

      if (invoiceId) {
        requestType = PATCH;
        requestURL = `invoice-v1/${invoiceId}`;
      }

      this.$store
        .dispatch(requestType, { url: requestURL, data: request })
        .then(({ data }) => {
          this.invoiceCreated = true;
          this.$store.dispatch(CLEAR_CUSTOMER);
          this.$store.dispatch(RESET_CREATE_STATE);
          this.$store.dispatch(CLEAR_LINE_ITEM);
          /*      this.clearLocalStorage(); */
          this.$nextTick(() => {
            if (requestType == POST) {
              this.$router.push(this.getDefaultRoute("invoice"));
            } else {
              this.$router.push(
                this.getDefaultRoute("invoice.detail", {
                  params: { id: data?.id },
                })
              );
            }
          });
        })
        .catch(() => {
          this.formLoading = false;
        });
    },
    get_attributes() {
      this.formLoading = true;

      this.$store
        .dispatch(QUERY, {
          url: "invoice/options",
          data: {
            ...this.$route.query,
            invoice: ObjectPath.get(this.$route, "params.id"),
            entity: this.dbInvoice.entity_id,
          },
        })
        .then((response) => {
          this.is_allowed_recur_invoice = ObjectPath.get(
            response,
            "data.is_allowed_recur_invoice"
          );
          this.dbInvoice.barcode = ObjectPath.get(response, "data.barcode");
          this.dbInvoice.visit = response?.data?.invoice?.visit;
          this.admin_sales = ObjectPath.get(response, "data.admin_sales", []);
          this.dbInvoice.prepared_by_id = ObjectPath.get(
            response,
            "data.user.id",
            null
          );

          this.dbUpdateInvoice = ObjectPath.get(response, "data");

          if (this.dbUpdateInvoice?.invoice?.barcode) {
            this.dbInvoice.barcode = this.dbUpdateInvoice?.invoice?.barcode;
          }
          this.dbQuotation = ObjectPath.get(response, "data.quotation");
          this.dbInvoice.term_condition_id = this.dbQuotation.term_condition_id;
          this.dbInvoice.term_conditions = this.dbQuotation.term_conditions;
          this.dbEnquiry = ObjectPath.get(response, "data.enquiry");
          this.dbVisit = ObjectPath.get(response, "data.visit");
          this.unit = ObjectPath.get(response, "data.uom_list");
          // this.entityList = ObjectPath.get(response , "data.entities", []);

          const specialistList = ObjectPath.get(
            response,
            "data.product_specialists",
            ObjectPath.get(response, "data.product_specialist", [])
          );
          this.productSpecialistList = Array.isArray(specialistList)
            ? specialistList
            : [];
          this.deliveryMethodList = ObjectPath.get(
            response,
            "data.delivery_methods",
            []
          );
          this.leadBookingByList = ObjectPath.get(
            response,
            "data.lead_booking_bys",
            []
          );
          this.entityList = ObjectPath.get(response, "data.entities");
          this.customerPaymentTerms =
            response.data.customer_payment_terms || [];

          // const productSpecialistData = ObjectPath.get(
          //   response,
          //   "data.product_specialist",
          //   []
          // );
          // if (productSpecialistData && productSpecialistData.length > 0) {
          //   this.productSpecialistList = [
          //     ...this.productSpecialistList,
          //     ...productSpecialistData,
          //   ];
          // }

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Invoice", route: "invoice" },
            { title: "Create" },
            { title: this.dbInvoice.barcode },
          ]);

          this.$store.dispatch(
            SET_UOM,
            ObjectPath.get(response, "data.uom_list", [])
          );
          this.$store.dispatch(
            SET_GST,
            ObjectPath.get(response, "data.entity.gstvalue", 0)
          );
          this.adminNoteList = ObjectPath.get(
            response,
            "data.admin_notes_list",
            []
          );
          this.clientNoteList = ObjectPath.get(
            response,
            "data.client_notes_list",
            []
          );
          this.paymentTermList = ObjectPath.get(
            response,
            "data.payment_terms_list",
            []
          );
          this.termsConditionList = ObjectPath.get(
            response,
            "data.term_conditions_list",
            []
          );
          this.paymentDueList = ObjectPath.get(
            response,
            "data.payment_terms",
            []
          );

          let defaultPaymentTermObject = this.lodash.find(
            this.paymentTermList,
            {
              primary: 1,
            }
          );
          if (defaultPaymentTermObject) {
            this.dbInvoice.payment_term_id = defaultPaymentTermObject.id;
            this.dbInvoice.payment_terms = defaultPaymentTermObject.description;
          }

          let defaultTermConditionObject = this.lodash.find(
            this.termsConditionList,
            {
              primary: 1,
            }
          );
          if (defaultTermConditionObject) {
            this.dbInvoice.term_condition_id = defaultTermConditionObject.id;
            this.dbInvoice.term_conditions =
              defaultTermConditionObject.description;
          }

          let defaultClientObject = this.lodash.find(this.clientNoteList, {
            primary: 1,
          });
          if (defaultClientObject && !this.dbInvoice.client_note) {
            this.dbInvoice.client_note_id = defaultClientObject.id;
            this.dbInvoice.client_note = defaultClientObject.description;
          }

          let defaultAdminObject = this.lodash.find(this.adminNoteList, {
            primary: 1,
          });
          if (defaultAdminObject) {
            this.dbInvoice.admin_note_id = defaultAdminObject.id;
            this.dbInvoice.admin_note = defaultAdminObject.description;
          }

          if (this.dbUpdateInvoice?.invoice?.id) {
            this.dbInvoice.payment_due =
              this.dbUpdateInvoice?.invoice?.payment_due;
            this.dbInvoice.admin_note_id =
              this.dbUpdateInvoice?.invoice?.admin_note_id;
            this.dbInvoice.admin_note =
              this.dbUpdateInvoice?.invoice.admin_note;

            this.dbInvoice.client_note_id =
              this.dbUpdateInvoice?.invoice?.client_note_id;
            this.dbInvoice.client_note =
              this.dbUpdateInvoice?.invoice.client_note;

            this.dbInvoice.prepared_by_id =
              this.dbUpdateInvoice?.invoice?.prepared_by_id;

            this.dbInvoice.event_purpose =
              this.dbUpdateInvoice?.invoice.event_purpose;
            this.dbInvoice.entity_id = this.lodash.toSafeInteger(
              this.dbUpdateInvoice?.invoice?.entity_id
            );
            this.dbInvoice.term_condition_id =
              this.dbUpdateInvoice?.invoice.term_condition_id;
            this.dbInvoice.term_conditions =
              this.dbUpdateInvoice?.invoice.term_conditions;

            this.dbInvoice.payment_term_id =
              this.dbUpdateInvoice?.invoice.payment_term_id;
            this.dbInvoice.payment_terms =
              this.dbUpdateInvoice?.invoice.payment_terms;

            this.dbInvoice.title = this.dbUpdateInvoice?.invoice?.title;
            this.dbInvoice.billing_type = this.getInvoiceType(
              this.dbUpdateInvoice?.invoice?.billing_type
            );
            this.dbInvoice.recurring_duration_new =
              this.dbUpdateInvoice?.invoice?.recurring_duration_new;
            this.dbInvoice.recurring_type =
              this.dbUpdateInvoice?.invoice?.recurring_type;
            this.dbInvoice.description =
              this.dbUpdateInvoice?.invoice?.description;
            this.dbInvoice.customer_ref =
              this.dbUpdateInvoice?.invoice?.customer_ref;
            this.dbInvoice.date = this.dbUpdateInvoice?.invoice?.date;
            this.dbInvoice.po_number = this.dbUpdateInvoice?.invoice?.po_number;
            this.dbInvoice.pos_receipt_no =
              this.dbUpdateInvoice?.invoice?.pos_receipt_no;
            this.dbInvoice.referral_fee =
              this.dbUpdateInvoice?.invoice?.referral_fee;
            this.dbInvoice.promotion = this.dbUpdateInvoice?.invoice?.promotion;
            this.dbInvoice.invoice_specialist_type =
              this.dbUpdateInvoice?.invoice?.invoice_specialist_type;

            this.dbInvoice.product_specialist =
              this.dbUpdateInvoice?.invoice?.product_specialist;
            this.setLeadBookingBy(
              this.dbUpdateInvoice?.invoice?.lead_booking_by ?? null,
              this.dbUpdateInvoice?.invoice?.lead_booking_by_other ?? null
            );

            this.dbInvoice.group_by = this.dbUpdateInvoice?.invoice?.group_by;

            this.dbInvoice.delivery_method =
              this.dbUpdateInvoice?.invoice?.delivery_method;

            this.dbInvoice.old_invoice_no =
              this.dbUpdateInvoice?.invoice?.old_invoice_no;

            this.dbInvoice.notify_billing_contact_person =
              this.dbUpdateInvoice?.invoice?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbUpdateInvoice?.invoice?.notify_property_contact_person;

            this.dbInvoice.outlet = this.lodash.toSafeInteger(
              this.dbUpdateInvoice?.invoice?.outlet
            );

            this.fetchOutlets(this.dbInvoice.entity_id, this.dbInvoice.outlet);

            this.dbInvoice.attachments = [];

            this.$store.commit(
              SET_CUSTOMER,
              this.dbUpdateInvoice?.invoice?.customer_relation
            );
            this.$store.commit(
              SET_PROPERTY,
              this.dbUpdateInvoice?.invoice?.property_relation
            );
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbUpdateInvoice?.invoice?.property_contact_person_relation
            );
            this.$store.commit(
              SET_BILLING,
              this.dbUpdateInvoice?.invoice?.billing_relation
            );
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbUpdateInvoice?.invoice?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label:
                this.dbUpdateInvoice?.invoice?.ctx_discount_label ?? null,
              ctx_discount_value:
                this.dbUpdateInvoice?.invoice?.ctx_discount_value ?? 0,
              ctx_discount_type:
                this.dbUpdateInvoice?.invoice?.ctx_discount_type ?? 1,
              discount_type: this.dbUpdateInvoice?.invoice?.discount_type ?? 1,

              discount_value:
                this.dbUpdateInvoice?.invoice?.discount_value ?? 0,

              deposit_type:
                this.dbUpdateInvoice?.invoice?.deposit_value_type ?? 1,
              deposit_value: this.dbUpdateInvoice?.invoice?.deposit_value ?? 0,

              tax_active: this.dbUpdateInvoice?.invoice?.tax_active ?? false,
              adjustment: this.dbUpdateInvoice?.invoice?.adjustment ?? 0,
              show_price: true,
              discount_level:
                this.dbUpdateInvoice?.invoice?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbUpdateInvoice?.invoice?.line_item ?? []
            );
            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Invoice", route: "invoice" },
              { title: "Update" },
              { title: this.dbInvoice.barcode },
            ]);
          }
          if (this.dbQuotation?.id) {
            this.dbUpdateInvoice.invoice = this.dbQuotation;
            this.related_type = 1;
            this.dbInvoice.title = this.dbQuotation?.title;

            this.dbInvoice.entity_id = this.dbQuotation?.entity_id;
            this.dbInvoice.entity_name = this.dbQuotation?.entity;
            this.dbInvoice.product_specialist = this.dbQuotation
              ?.product_specialist
              ? [this.dbQuotation.product_specialist]
              : [];

            const quotationOutletId = this.lodash.toSafeInteger(
              this.dbQuotation?.outlet
            );
            this.fetchOutlets(this.dbInvoice.entity_id, quotationOutletId);
            this.dbInvoice.billing_type = this.getInvoiceType(
              this.dbQuotation?.billing_type
            );
            this.dbInvoice.recurring_duration_new =
              this.dbQuotation?.recurring_duration_new;
            this.dbInvoice.recurring_type = this.dbQuotation?.recurring_type;
            this.dbInvoice.description = this.dbQuotation?.description;
            this.dbInvoice.customer_ref = this.dbQuotation?.reference;
            this.dbInvoice.notify_billing_contact_person =
              this.dbQuotation?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbQuotation?.notify_property_contact_person;

            this.dbInvoice.client_note_id = 0;
            this.dbInvoice.client_note =
              this.dbQuotation?.client_note || this.defaultClientNote;
            this.dbInvoice.po_number = this.dbQuotation?.po_number;
            this.dbInvoice.pos_receipt_no = this.dbQuotation?.pos_receipt_no;
            this.dbInvoice.referral_fee = this.dbQuotation?.referral_fee;
            this.dbInvoice.promotion = this.dbQuotation?.promotion;

            this.dbInvoice.prepared_by_id = this.dbQuotation?.prepared_by_id;

            this.dbInvoice.outlet = this.lodash.toSafeInteger(
              this.dbQuotation?.outlet
            );
            this.dbInvoice.group_by = this.dbQuotation?.group_buy;
            this.setLeadBookingBy(
              this.dbQuotation?.lead_booking_by ?? null,
              this.dbQuotation?.lead_booking_by_other ?? null
            );
            this.dbInvoice.event_purpose = this.dbQuotation?.event_purpose;
            this.dbInvoice.admin_note_id = 0;
            this.dbInvoice.admin_note = this.dbQuotation?.admin_note;
            this.dbInvoice.attachments = [];
            this.dbInvoice.billing_type = "one-off";
            this.dbInvoice.entity_id = this.lodash.toSafeInteger(
              this.dbQuotation?.entity_id
            );
            this.dbInvoice.entity_name = this.dbQuotation?.entity;
            this.fetchOutlets(this.dbInvoice.entity_id);
            this.$store.commit(
              SET_CUSTOMER,
              this.dbQuotation?.customer_relation
            );
            this.$store.commit(
              SET_PROPERTY,
              this.dbQuotation?.property_relation
            );
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbQuotation?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbQuotation?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbQuotation?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label: this.dbQuotation?.ctx_discount_label ?? null,
              ctx_discount_value: this.dbQuotation?.ctx_discount_value ?? 0,
              ctx_discount_type: this.dbQuotation?.ctx_discount_type ?? 1,
              discount_type: this.dbQuotation?.discount_type ?? 1,
              discount_value: this.dbQuotation?.discount_value ?? 0,
              tax_active: this.dbQuotation?.tax_active ?? false,
              adjustment: this.dbQuotation?.adjustment ?? 0,
              show_price: true,
              discount_level: this.dbQuotation?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbQuotation?.line_item ?? []
            );
          }
          if (this.dbEnquiry?.id) {
            this.dbUpdateInvoice.invoice = this.dbEnquiry;
            this.related_type = 6;
            this.dbInvoice.title = this.dbEnquiry?.title;
            this.dbInvoice.description = this.dbEnquiry?.problem;
            this.dbInvoice.customer_ref = this.dbEnquiry?.reference;
            this.dbInvoice.attachments = [];
            this.dbInvoice.billing_type = "one-off";
            // Ensure entity is preselected when creating invoice from enquiry
            this.dbInvoice.entity_id = this.lodash.toSafeInteger(
              this.dbEnquiry?.entity_id
            );
            this.dbInvoice.entity_name = this.dbEnquiry?.entity;
            const enquiryOutletId = this.lodash.toSafeInteger(
              this.dbEnquiry?.outlet
            );
            this.fetchOutlets(this.dbInvoice.entity_id, enquiryOutletId);
            this.$store.commit(SET_CUSTOMER, this.dbEnquiry?.customer_relation);
            this.$store.commit(SET_PROPERTY, this.dbEnquiry?.property_relation);
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbEnquiry?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbEnquiry?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbEnquiry?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label: this.dbEnquiry?.ctx_discount_label ?? null,
              ctx_discount_value: this.dbEnquiry?.ctx_discount_value ?? 0,
              ctx_discount_type: this.dbEnquiry?.ctx_discount_type ?? 1,
              discount_type: this.dbEnquiry?.discount_type ?? 1,
              discount_value: this.dbEnquiry?.discount_value ?? 0,
              tax_active: this.dbEnquiry?.tax_active ?? false,
              adjustment: this.dbEnquiry?.adjustment ?? 0,
              show_price: true,
              discount_level: this.dbEnquiry?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbEnquiry?.line_item ?? []
            );
          }

          if (this.dbVisit?.id) {
            this.dbUpdateInvoice.invoice = this.dbVisit;
            this.related_type = 3;
            this.dbInvoice.title = this.dbVisit?.title;
            this.dbInvoice.visit = this.dbVisit?.id;
            // this.dbInvoice.billing_type = this.dbVisit?.billing_type;
            this.dbInvoice.recurring_duration_new =
              this.dbVisit?.recurring_duration_new;
            this.dbInvoice.recurring_type = this.dbVisit?.recurring_type;
            this.dbInvoice.description = this.dbVisit?.description;
            this.dbInvoice.customer_ref = this.dbVisit?.reference;
            this.dbInvoice.delivery_method =
              this.dbVisit?.delivery_method ?? null;
            this.dbInvoice.billing_type = "one-off";

            /*      this.dbInvoice.notify_billing_contact_person =
              this.dbVisit?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbVisit?.notify_property_contact_person; */

            this.dbInvoice.client_note_id = 0;
            this.dbInvoice.client_note =
              this.dbVisit?.client_note || this.defaultClientNote;

            this.dbInvoice.admin_note_id = 0;
            this.dbInvoice.admin_note = this.dbVisit?.admin_note;

            this.dbInvoice.entity_id = this.dbVisit?.entity_id;
            this.dbInvoice.entity_name = this.dbVisit?.entity;
            const visitOutletId = this.lodash.toSafeInteger(
              this.dbVisit?.outlet
            );

            this.fetchOutlets(this.dbInvoice.entity_id, visitOutletId || null);

            this.dbInvoice.term_conditions = this.dbVisit?.term_conditions;
            this.dbInvoice.term_condition_id = this.dbVisit?.term_condition_id;
            this.dbInvoice.attachments = [];

            this.$store.commit(SET_CUSTOMER, this.dbVisit?.customer_relation);
            this.$store.commit(SET_PROPERTY, this.dbVisit?.property_relation);
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbVisit?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbVisit?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbVisit?.billing_contact_person_relation
            );
          }
        })
        .catch((error) => {
          this.logError(error);
          /*  this.goBack(); */
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    onPaymentDialogClose() {
      this.managePaymentDialog = false;

      // Reload invoice/options
      this.get_attributes();
    },
    getInvoiceType(type) {
      if (type == "one-off") {
        return "one-off";
      } else if (type == "recurring-based-on-quote") {
        return "recurring";
      } else if (type == "recurring") {
        return "recurring";
      }
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
  },
  watch: {
    // $route (to, from){
    //     if(to != from){
    //       this.clearLocalStorage()
    //     }
    // }

    "dbInvoice.visit"(val) {
      if (!this.isVisitChanged) {
        return;
      }

      const id = this.lodash.toSafeInteger(val);
      if (!id && this.$refs.invoiceLineItem) {
        const comp = this.$refs.invoiceLineItem;
        comp.selected_line_items = (comp.selected_line_items || []).filter(
          (i) => !i.visit_origin
        );
        this.$nextTick(() => comp.emit_values());
        return;
      }

      if (!id) {
        return;
      }

      const selectedVisit = this.vRelatedVisits.find((v) => v.value === id);
      const ticketId = this.lodash.toSafeInteger(selectedVisit?.ticket);

      if (this.$refs.invoiceLineItem?.selected_line_items) {
        this.$refs.invoiceLineItem.selected_line_items =
          this.$refs.invoiceLineItem.selected_line_items.filter(
            (i) => !i.visit_origin
          );
      }

      this.$store
        .dispatch(QUERY, {
          url: `visit-v1/${ticketId}/line-items`,
          data: { type: 3 },
        })
        .then(({ data }) => {
          const items = Array.isArray(data) ? data : [];
          const currentItems =
            this.$refs.invoiceLineItem?.selected_line_items || [];

          const seen = new Set(currentItems.map((i) => this.getItemKey(i)));

          const incoming = items
            .map((row) => ({
              ...row,
              discount_type: this.lodash.toSafeInteger(row.discount_type),
              cimages: row.item_images,
              visit_origin: true,
            }))
            .filter((row) => {
              const key = this.getItemKey(row);
              if (seen.has(key)) return false;
              seen.add(key);
              return true;
            });

          if (this.$refs.invoiceLineItem && incoming.length) {
            this.$refs.invoiceLineItem.update_line_item(incoming);
          }
        })
        .catch(() => {});
    },
    vCustomerId(newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch(GET_CUSTOMER_RELATED, {
          id: newVal,
          type: ["quotation", "visit", "invoice"],
        });
      }

      if (oldVal && newVal !== oldVal && this.$refs.invoiceLineItem) {
        this.$refs.invoiceLineItem.selected_line_items =
          this.$refs.invoiceLineItem.selected_line_items.filter(
            (item) => item.type !== "equipment"
          );
        this.$nextTick(() => {
          this.$refs.invoiceLineItem.calculate_total();
          this.$refs.invoiceLineItem.emit_values();
        });
      }
    },
    vCustomer(customer) {
      if (!customer || this.invoiceEditId) return;

      const paymentTerm = this.customerPaymentTerms.find(
        (item) => item.text === customer.payment_terms
      );

      if (paymentTerm) {
        this.dbInvoice.payment_due = paymentTerm.id;
      }
    },
  },

  mounted() {
    this.get_attributes();
    this.invoiceEditId = this.lodash.toSafeInteger(this.$route.params.id);
    if (this.dbUpdateInvoice?.invoice?.id > 1) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Invoice", route: "invoice" },
        { title: "Update" },
      ]);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Invoice", route: "invoice" },
        { title: "Create" },
      ]);
    }
  },
  destroyed() {
    this.$store.dispatch(CLEAR_INVOICE);
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  beforeDestroy() {
    KTCookie.setCookie("kt_aside_toggle_state", "off");
    localStorage.setItem("kt_aside_toggle_state", "off");
  },
  created() {
    this.todayDate = moment().format("YYYY-MM-DD");
    this.dbInvoice.date = this.todayDate;
    this.dbInvoice.ticket = ObjectPath.get(this.$route, "query.ticket");
    this.dbInvoice.quotation = ObjectPath.get(this.$route, "query.quotation");
  },
  beforeCreate() {
    KTCookie.setCookie("kt_aside_toggle_state", "on");
    localStorage.setItem("kt_aside_toggle_state", "on");
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  computed: {
    ...mapGetters([
      "reCustomerId",
      "vRelatedQuotations",
      "vRelatedVisits",
      "vCustomer",
      "vProperty",
      "vPropertyContact",
      "vBilling",
      "vBillingContact",
      "reCustomerDialog",
      "vCustomerId",
      "vPropertyId",
      "vPropertyContactId",
      "vBillingId",
      "vBillingContactId",
      "vSelectedLineItem",
      "vCalculations",
      "recurringInvoiceScheduleTypeList",
      "invoiceRecurringSchedule",
      "invoiceScheduleOutput",
      "customError",
      "currentUser",
    ]),

    invoiceMinDate() {
      if (this.invoiceEditId > 0) {
        return moment().startOf("month").format("YYYY-MM-DD");
      }
      return null;
    },

    invoiceMaxDate() {
      if (this.invoiceEditId > 0) {
        return moment().endOf("month").format("YYYY-MM-DD");
      }
      return null;
    },

    isOldInvoiceRequired() {
      if (!this.dbInvoice.date) {
        return false;
      }
      return moment(this.dbInvoice.date).isBefore(
        moment("2026-08-01", "YYYY-MM-DD")
      );
    },
    selectedEntityObj() {
      if (!this.dbInvoice.entity_id) return null;
      return (
        this.entityList.find(
          (entity) => Number(entity.id) === Number(this.dbInvoice.entity_id)
        ) ||
        (this.dbInvoice.entity_name
          ? { name: this.dbInvoice.entity_name }
          : null)
      );
    },
    selectedEntityId() {
      return this.dbInvoice.entity_id ? Number(this.dbInvoice.entity_id) : 0;
    },

    isQuotationInvoice() {
      return Boolean(
        this.dbQuotation?.id ||
          this.lodash.toSafeInteger(this.dbUpdateInvoice?.invoice?.quotation)
      );
    },

    isEnquiryInvoice() {
      return Boolean(
        this.dbEnquiry?.id ||
          this.lodash.toSafeInteger(this.dbUpdateInvoice?.invoice?.enquiry)
      );
    },

    isVisitInvoice() {
      return Boolean(
        this.dbVisit?.id ||
          this.lodash.toSafeInteger(this.dbUpdateInvoice?.invoice?.visit)
      );
    },

    isCustomerDisabled() {
      return (
        this.isQuotationInvoice || this.isEnquiryInvoice || this.isVisitInvoice
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.invoiceCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.invoice-create-page {
  border-top: solid 8px #f7941e;
  label {
    padding-left: 5px;
    font-weight: 600;
  }
  p {
    padding-left: 5px;
  }
}
</style>
